<template>
  <div class="container">
    <div class="container_form">
      <el-form
        :inline="true"
        :model="formObj"
        style="
          padding-top: 20px;
          padding-left: 20px;
          margin-bottom: 20px;
          background-color: #fff;
          border-radius: 8px;
        "
        size="small"
        ref="formRefs"
      >
        <el-form-item label="结算批次名称" prop="settlementBatchName">
          <el-select
            filterable
            style="width: 100%"
            v-model="formObj.settlementBatchName"
            placeholder="请选择结算批次名称"
          >
            <el-option
              v-for="(item, index) in queryFormSettlementList"
              :key="index"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="结算师傅名称" prop="installerIds">
          <el-select
            multiple
            style="width: 100%"
            filterable
            v-model="formObj.installerIds"
            placeholder="请选择结算师傅名称"
          >
            <el-option
              v-for="item in allUserList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司名称" prop="companyIds">
          <el-select
            multiple
            style="width: 100%"
            filterable
            v-model="formObj.companyIds"
            placeholder="请选择公司名称"
          >
            <el-option
              v-for="item in companyList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="item.companyId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="付款时间" prop="paymentTime">
          <!-- <el-date-picker
            style="width: 100%"
            v-model="formObj.paymentTime"
            type="datetime"
            placeholder="选择付款时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker> -->
          <el-date-picker
            style="width: 220px"
            v-model="formObj.paymentTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="getPageData(true)"
            >查询</el-button
          >
          <el-button type="info" size="mini" @click="reset">重置</el-button>
          <el-button type="warning" size="mini" @click="getPageData(true, 1)"
            >已删除</el-button
          >
        </el-form-item>
      </el-form>
      <div class="container_table">
        <BaseTable
          :tableData="tableData"
          :columns="columns"
          :showPagination="true"
          :showOperationColumn="true"
          :total="total"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
        >
          <template #settlementBatchName="{ row }">
            <span class="batch-name-link" @click="jumpToReport(row.settlementBatchName)">{{ row.settlementBatchName }}</span>
          </template>
          <template #paymentTypeStr="{ row }">
            <span v-if="row.paymentTypeStr === '直接支付'">
              {{ row.paymentTypeStr }}
            </span>
            <el-button
              v-else
              type="text"
              size="small"
              @click="seeMergeRecords(row)"
              >{{ row.paymentTypeStr }}</el-button
            >
          </template>
          <template #attachmentIds="{ row }">
            <span v-if="row.attachmentIds">
              <el-button
                type="text"
                size="small"
                @click="seeFileList(row.attachmentIds)"
                >{{ row.attachmentIds.split(",").length }}</el-button
              >
            </span>
          </template>
          <template #operation="{ row }">
            <el-tooltip effect="dark" content="修改" placement="top-end">
              <el-button
                type="warning"
                icon="el-icon-edit"
                size="mini"
                style="margin: 0 5px"
                circle
                @click="edit(row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip effect="dark" content="删除" placement="top-end">
              <el-popconfirm
                :title="
                  row.paymentTypeStr === '直接支付'
                    ? '确认删除吗？'
                    : '（合并支付删除将会影响多个结算单）确认删除吗？'
                "
                @confirm="deleteData(row)"
              >
                <el-button
                  content="删除"
                  slot="reference"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="mini"
                ></el-button>
              </el-popconfirm>
            </el-tooltip>
          </template>
        </BaseTable>
      </div>
      <el-dialog
        title="修改"
        :visible.sync="editDialog"
        width="400px"
        :close-on-click-modal="false"
      >
        <UpLoad
          :fileSize="100"
          ref="uploadRefs"
          :accept="'all'"
          @remove="removeFile"
          :limit="100"
          @uploadSuccess="handleUploadSuccess"
        ></UpLoad>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeFileUpload()" size="small">取 消</el-button>
          <el-button type="primary" @click="editSubmit" size="small"
            >提 交</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 文件列表 -->
    <FileList ref="fileListRefs"></FileList>
    <!-- 合并支付记录 -->
    <MergePaymentRecords ref="mergePaymentRecordsRefs" />
  </div>
</template>

<script>
import BaseTable from "@/components/BaseTable";
import UpLoad from "@/components/UpLoad";
import FileList from "@/components/FileList";
import MergePaymentRecords from "@/views/settlement-model/components/MergePaymentRecords.vue";
export default {
  name: "payRecord",
  components: {
    BaseTable,
    UpLoad,
    FileList,
    MergePaymentRecords,
  },
  data() {
    return {
      formObj: {
        settlementBatchName: "",
        installerIds: [],
        companyIds: [],
        paymentTime: [],
      },
      tableData: [],
      columns: [
        {
          prop: "settlementBatchName",
          label: "结算批次名称",
          slot: "settlementBatchName",
        },
        {
          prop: "userIdStr",
          label: "结算师傅",
        },
        {
          prop: "companyName",
          label: "公司名称",
        },
        {
          prop: "paymentTypeStr",
          label: "支付类型",
          slot: "paymentTypeStr",
        },
        {
          prop: "settlementOrderAmount",
          label: "结算单金额",
        },
        {
          prop: "allocatedAmount",
          label: "收到金额",
        },
        {
          prop: "paymentMethod",
          label: "付款方式",
        },
        {
          prop: "paymentAmount",
          label: "支付金额",
        },
        {
          prop: "attachmentIds",
          label: "付款凭证",
          slot: "attachmentIds",
        },
        {
          prop: "paymentTime",
          label: "付款时间",
          width: 130,
        },
        {
          prop: "createdByStr",
          label: "操作人",
        },
        {
          prop: "updateTime",
          label: "操作时间",
          width: 130,
        },
        {
          prop: "statusStr",
          label: "状态",
        },
        {
          prop: "remarks",
          label: "备注",
          showOverflowTooltip: true,
        },
      ],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      allUserList: this.$store.state.allUserList || [],
      companyList: this.$store.state.company || [],
      editDialog: false,
      queryFormSettlementList: [],
      editForm: {
        attachmentIds: [],
      },
      fileList: [],
      currentRow: {},
    };
  },
  created() {
    this.getPageData(true);
    this.getSettlementList();
    this.loadAllUserList();
  },
  methods: {
    // 加载所有用户列表
    async loadAllUserList() {
      try {
        // 调用store的action来获取最新的用户列表
        await this.$store.dispatch('setAllUserList');
        // 更新本地数据
        this.allUserList = this.$store.state.allUserList;
      } catch (error) {
        console.error('加载用户列表失败:', error);
        this.$message.error('加载用户列表失败');
      }
    },
    closeFileUpload() {
      this.$refs.uploadRefs.clearFileList();
      this.editDialog = false;
    },
    seeMergeRecords(row) {
      this.$refs.mergePaymentRecordsRefs.open(row.id);
    },
    seeFileList(ids) {
      const fileList = ids.split(",");
      this.$refs.fileListRefs.open(fileList);
    },
    removeFile(file, fileList) {
      this.editForm.attachmentIds = fileList.map((item) => item.uid);
    },
    handleUploadSuccess(res) {
      this.editForm.attachmentIds.push(res);
    },
    editSubmit() {
      if (
        Array.isArray(this.editForm.attachmentIds) &&
        this.editForm.attachmentIds.length > 0
      ) {
        this.editForm.attachmentIds = this.editForm.attachmentIds.join(",");
      } else {
        this.editForm.attachmentIds = "";
      }

      this.axios({
        url: `/v1/web/settlement/payment-record/edit/${this.currentRow.id}`,
        method: "post",
        data: {
          userId: this.currentRow.userId,
          paymentTime: this.currentRow.paymentTime,
          paymentMethod: this.currentRow.paymentMethod,
          paymentAmount: this.currentRow.paymentAmount,
          settlementOrderIds: [this.currentRow.settlementOrderId],
          paymentMethodDictId: this.currentRow.paymentMethodDictId,
          attachmentIds: this.editForm.attachmentIds,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("修改成功");
          this.editDialog = false;
          this.getPageData(false);
        }
      });
    },
    getSettlementList() {
      this.axios({
        method: "post",
        url: "/pending-settlement-order/listSettlementName",
      }).then((res) => {
        this.queryFormSettlementList = res.data.data;
      });
    },
    deleteData(row) {
      this.axios({
        url: `/v1/web/settlement/payment-record/del/${row.id}`,
        method: "DELETE",
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("删除成功");
          this.getPageData(false);
        }
      });
    },
    edit(row) {
      this.currentRow = row;
      this.editForm.attachmentIds = [];
      if (row.attachmentIds && row.attachmentIds !== "") {
        this.axios({
          url: "/attachment/list",
          method: "POST",
          data: {
            ids: row.attachmentIds,
          },
        }).then((res) => {
          if (res.data.data && res.data.data.length > 0) {
            this.fileList = res.data.data.map((item) => {
              return {
                name: item.fileName,
                url: item.fileUrl,
                uid: item.id,
              };
            });
            this.$refs.uploadRefs.fileList = this.fileList;
            this.editForm.attachmentIds = this.fileList.map((item) => item.uid);
          }
        });
      }
      this.editDialog = true;
    },
    reset() {
      this.$refs.formRefs.resetFields();
    },
    onSizeChange(val) {
      this.pageSize = val;
      this.getPageData(false);
    },
    onCurrentChange(val) {
      this.currentPage = val;
      this.getPageData(false);
    },
    getPageData(flag, isDeleted) {
      if (flag) {
        this.pageSize = 10;
        this.currentPage = 1;
      }
      let data = {
        size: this.pageSize,
        page: this.currentPage,
        queryInfoParams: {
          ...this.formObj,
          isDeleted: isDeleted || 0,
          paymentTime: this.formObj.paymentTime.join(","),
        },
      };
      this.axios({
        url: "/v1/web/settlement/payment-record/list",
        method: "post",
        data,
      }).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.list;
          this.total = res.data.data.total;
        }
      });
    },
    jumpToReport(batchName) {
      // 跳转到结算报表页面并自动查询指定批次
      this.$router.push({
        path: '/home-admin/settlementManage/report',
        query: { 
          settlementBatchName: batchName,
          autoSearch: 'true'
        }
      });
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;
}

.container_table {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px 5px 20px 20px;
}
.batch-name-link {
  color: #409EFF;
  cursor: pointer;
}
.batch-name-link:hover {
  text-decoration: underline;
}
</style>
